import Main from './navigation/Main';

function App() {
  return (
    <Main/>
  );
}

export default App;
